import dynamic from "next/dynamic";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Container, Row, Col } from "react-bootstrap";
import img from "../public/bh.png";
import { useRouter } from "next/router";
import AnchorLink from "../components/anchor/Anchor";
import Image from "next/image";
import PageLayout from "../components/layout/PageLayout";
import { staticPath } from "../utils";

const Seo = dynamic(() => import("../components/seo/Seo"), {
  ssr: false,
});

const SubTitle = dynamic(() => import("../components/title/SubTitle"), {
  ssr: false,
});

const Error = dynamic(() => import("../components/error/Error"), {
  ssr: false,
});

const blogdahafazla = ({
  news,
  navbar,
  footer,
  navbarData,
  navbarFooterData,
}) => {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <PageLayout
      navbarData={navbarData}
      navbar={navbar}
      footer={footer}
      navbarFooterData={navbarFooterData}
    >
      <Seo
        title={t("home:blog")}
        keywords={t("home:blog")}
        description={t("home:blog")}
        url={router.asPath}
      />
      <SubTitle
        pageName={t("home:blog")}
        pageRoute={"/blog"}
        TitleText={t("home:blog")}
        style={{ margin: 0 }}
      />
      <Container
        style={{
          paddingTop: "20px",
          paddingBottom: "100px",
          backgroundImage: `url(${img.src})`,
          backgroundSize: "44%",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center bottom",
        }}
      >
        {/* <h1>{t("home:our_news")}</h1> */}
        <div className={"card_more_news"}>
          <Row>
            {news.map((item, index) => (
              <Col md={6} key={index}>
                <AnchorLink href={`/blogicerik/${item.seoUrl}`}>
                  <Row className="d-flex align-items-center h-100">
                    <Col md={3}>
                      <Image
                        width={103}
                        height={63}
                        src={process.env.IMAGE_URL + item.pictureUrl}
                        alt={item.title}
                        className="w-100"
                        layout="responsive"
                      />
                    </Col>
                    <Col md={9}>
                      <h5>{item.title}</h5>
                    </Col>
                  </Row>
                </AnchorLink>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </PageLayout>
  );
};

export async function getStaticProps(context) {
  const [data, navbarData, navbarFooterData, footerData] = await Promise.all([
    fetch(`${process.env.ISNETURL}/blog`).then((res) => res.json()),
    fetch(`${process.env.ISNETURL}/menu`).then((res) => res.json()),
    fetch(`${process.env.ISNETURL}/menu/footermenu`).then((res) => res.json()),
    fetch(`${process.env.API_URL}/footer`).then((res) => res.json()),
  ]);

  const navbarFilter =
    navbarData && navbarData?.filter((item) => item.isDeleted === false);

  let navbar, footer;
  if (navbarFilter || footerData) {
    const nav = staticPath(navbarFilter);
    navbar = nav;
    footer = footerData;
  }

  return {
    props: {
      news: data.filter((item) => !item.isDeleted),
      navbar,
      footer,
      navbarData,
      navbarFooterData,
      ...(await serverSideTranslations(context.locale, ["home"])),
    },
    revalidate: 10,
  };
}

export default blogdahafazla;
